var themeOptions = function (theme) { return ({
    components: {
        MuiRadio: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    paddingTop: theme.spacing(0.25),
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=radioTheme.js.map